import { SERVER_API_URL } from "../app.constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class JobTypeService {
    private resourceUrl = SERVER_API_URL + 'api/job-types';

    constructor(
        private http: HttpClient) {
    }

    getJobTypes(includeInactive = false): Observable<HttpResponse<Nema.Crew.Model.JobType[]>> {
        return this.http
            .get < Nema.Crew.Model.JobType[]>(`${this.resourceUrl}?includeInactive=${includeInactive}`, { observe: 'response' })
            .map((res: HttpResponse<Nema.Crew.Model.JobType[]>) => this.convertArrayResponse(res));
    }

    //private _convertResponse(res: HttpResponse<Nema.Crew.Model.JobType>): HttpResponse<Nema.Crew.Model.JobType> {
    //    const body: Nema.Crew.Model.JobType = this.convertItemFromServer(res.body);
    //    return res.clone({ body });
    //}

    private convertArrayResponse(res: HttpResponse<Nema.Crew.Model.JobType[]>): HttpResponse<Nema.Crew.Model.JobType[]> {
        const jsonResponse: Nema.Crew.Model.JobType[] = res.body;
        const body: Nema.Crew.Model.JobType[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer(jsonResponse[i]));
        }

        return res.clone({ body });
    }

    private convertItemFromServer(jobType: Nema.Crew.Model.JobType): Nema.Crew.Model.JobType{
        const copy: Nema.Crew.Model.JobType = Object.assign({}, jobType);
        return copy;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/job-type.service.ts